/* eslint-disable no-unused-vars */

import { localDate } from '../../../utils/misc';
import { useEffect, useState } from 'react';
import { Table, Badge, Spin, Button, Space, Typography, Tag } from 'antd';
import { get } from 'lodash-es';
import { createUseStyles } from 'react-jss';
import { Link } from 'react-router-dom';
import { useHostFilteredChargingSessions } from 'utils/queries/hostQueries';
import ChargerSessionModal from 'components/Modals/ChargerSessionModal';

const { Text } = Typography;

const useStyles = createUseStyles({
  onlineOfflineBadgeIcon: {
    '& .ant-badge-status-dot': {
      height: '11px',
      width: '11px',
    },
  },
});

export default function SessionsList({ filter }) {
  const classes = useStyles();
  const limit = 10;
  const {
    data: sessionsData,
    isLoading,
    isError,
  } = useHostFilteredChargingSessions({
    limit: 200,
    offset: 0,
  });
  const { data, count } = sessionsData || {};
  const [filteredData, setFilteredData] = useState([]);

  useEffect(() => {
    if (data?.length > 0) {
      if (filter === 'all') {
        setFilteredData(data);
      } else if (filter === 'active') {
        const filterData = data.filter(
          (o) =>
            (o.METER_STOP === 'null' && o.END_TIME === 'null') ||
            (o.METER_STOP === null && o.END_TIME === null),
        );
        setFilteredData(filterData);
      }
    }
  }, [filter, data, setFilteredData]);

  const [selectedSession, setSelectedSession] = useState('');
  const [openChargerSessionModal, setOpenChargerSessionModal] = useState(false);
  const toggleChargerSessionModal = () =>
    setOpenChargerSessionModal(!openChargerSessionModal);

  const columns = [
    {
      title: 'Transaction ID11',
      dataIndex: 'TRANSACTIONID',
      render: (text, session) => (
        <span
          style={{ fontWeight: 600, color: '#317ffe', cursor: 'pointer' }}
          onClick={() => {
            setSelectedSession(session?.TRANSACTIONID);
            toggleChargerSessionModal();
          }}
        >
          {session?.TRANSACTIONID}
        </span>
      ),
      key: 'TRANSACTIONID',
      width: 150,
    },
    {
      title: 'Queue ID',
      dataIndex: 'QUEUEID',
      render: (name, session) => (
        <>
          <Text>{session?.QUEUEID}</Text>
        </>
      ),
      key: 'QUEUEID',
      width: 450,
    },
    {
      title: 'Charger Id',
      dataIndex: 'CPID',
      render: (name, session) => (
        <>
          <Link to={`/admin/chargers/${session?.CPID}`}>{session?.CPID}</Link>
        </>
      ),
      key: 'CPID',
      width: 260,
    },
    {
      title: 'Connector',
      dataIndex: 'CONNECTORID',
      render: (name, session) => <>{session?.CONNECTORID}</>,
      width: 120,
      key: 'CONNECTORID',
      align: 'center',
    },
    {
      title: 'Started at',
      dataIndex: 'START_TIME',
      render: (name, session) => <>{localDate(session?.START_TIME)}</>,
      key: 'START_TIME',
      width: 170,
    },
    {
      title: 'Ended at',
      dataIndex: 'END_TIME',
      render: (name, session) => (
        <>
          {session?.END_TIME ? (
            localDate(session?.END_TIME)
          ) : (
            <Tag color="green" style={{ fontSize: '15px' }}>
              Charging
            </Tag>
          )}
        </>
      ),
      key: 'END_TIME',
      width: 170,
    },
  ];

  return (
    <>
      <Table
        columns={columns}
        dataSource={filteredData || []}
        scroll={{ y: '70vh' }}
        loading={isLoading}
        pagination={{
          defaultCurrent: 1,
          pageSize: limit,
          total: filteredData?.length,
          hideOnSinglePage: limit >= count,
          showSizeChanger: false,
        }}
      />

      <ChargerSessionModal
        modalOpen={openChargerSessionModal}
        toggleModalOpen={toggleChargerSessionModal}
        transactionId={selectedSession}
      />
    </>
  );
}
